import { Checkout } from "@comparaonline/cicl-funnel-schema";
import { Router, MapRoutes } from "../../../routes";
import { FirebaseClient } from "../../firebase";
import { updateCheckout } from "../helpers";

export type GoToPaymentMethodStep = (input: {
  business: string;
  checkout: Checkout;
  firebase: FirebaseClient;
  formId: string;
  offerId: string;
}) => Promise<void>;

export const goToPaymentMethodStep: GoToPaymentMethodStep = async ({
  checkout,
  firebase,
  ...query
}) => {
  await updateCheckout({
    data: { ...checkout, status: "" },
    documentId: query.formId,
    firebase
  });

  Router.pushRoute(
    MapRoutes.CHECKOUT_STEP,
    {
      ...query,
      initialStep: "payer"
    },
    { shallow: true }
  );
};
